function RRNotify($window) {
	this._$window = $window;
}

RRNotify.prototype.flush = function () {
	this._$window.rr_flush_onload();
	this._$window.r3();
};

module.exports = RRNotify;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-event-send.js
 **/